export { default as Step1 } from './Step1';
export { default as Step2 } from './Step2';
export { default as Step3 } from './Step3';
export { default as Deploy } from './Deploy';



// WEBPACK FOOTER //
// ./src/pages/base-managment/platoons/PlatoonTransitionPage/steps/index.js